import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes, FaHeartbeat } from 'react-icons/fa';
import './Navbar.css';

const NAV_LINKS = [
  { label: 'Home',     href: '/',            isRoute: true },
  { label: 'About',    href: '/#about' },
  { label: 'Products', href: '/#products' },
  { label: 'Catalogs', href: '/catalogs',    isRoute: true },
  { label: 'Why Us',   href: '/#why-us' },
  { label: 'Export',   href: '/#export' },
  { label: 'Contact',  href: '/#contact' },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled]  = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Lock body scroll when drawer is open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const close = () => setMenuOpen(false);

  const Brand = () => (
    <Link to="/" className="navbar__brand" onClick={close}>
      <span className="navbar__logo-icon"><FaHeartbeat /></span>
      <div className="navbar__logo-text">
        <span className="navbar__name">H.A Surgical</span>
        <span className="navbar__tagline">Medical Instruments</span>
      </div>
    </Link>
  );

  const Links = ({ onLinkClick }) => (
    <>
      {NAV_LINKS.map(({ label, href, isRoute }) => (
        <li key={label}>
          {isRoute ? (
            <Link to={href} className="navbar__link" onClick={onLinkClick}>{label}</Link>
          ) : (
            <a href={href} className="navbar__link" onClick={onLinkClick}>{label}</a>
          )}
        </li>
      ))}
      <li>
        <a href="/#contact" className="navbar__cta" onClick={onLinkClick}>Get Quote</a>
      </li>
    </>
  );

  return (
    <>
      {/* ── Top bar ── */}
      <nav className={`navbar${scrolled ? ' navbar--scrolled' : ''}`}>
        <div className="container navbar__inner">
          <Brand />

          {/* Desktop links — inside nav is fine on desktop (no backdrop-filter stacking issue) */}
          <ul className="navbar__desktop">
            <Links onLinkClick={close} />
          </ul>

          <button
            className="navbar__toggle"
            onClick={() => setMenuOpen(v => !v)}
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={menuOpen}
          >
            {menuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </nav>

      {/* ── Mobile drawer — OUTSIDE <nav> so backdrop-filter doesn't clip it ── */}
      <div className={`navbar__drawer${menuOpen ? ' navbar__drawer--open' : ''}`} aria-hidden={!menuOpen}>
        <ul className="navbar__drawer-list">
          <Links onLinkClick={close} />
        </ul>
      </div>

      {/* Backdrop */}
      {menuOpen && <div className="navbar__backdrop" onClick={close} aria-hidden="true" />}
    </>
  );
}
